import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="testimonials-title" data-id="element-310" data-mp="3mf7ly4stt268">
      <div className="mx-auto max-w-5xl" data-id="element-311" data-mp="3r8tt5hg80dun">
        <div id="testimonials-title" data-id="element-312" data-mp="1r16nsk63jd">
          <SectionHeading eyebrow="What physicians are saying" title="Built around the decisions you actually make" data-id="element-313" data-mp="obgj6z2751" />
        </div>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-314" data-mp="91e0n41q8z9s">
          <div className="flex items-center gap-1.5" data-id="element-315" data-mp="9031xin52hpj">
            <span className="flex" aria-hidden="true" data-id="element-316" data-mp="dznzppqkok0o">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-rose text-rose" data-id="element-317" data-mp="2aukejf1s63h0" />)}
            </span>
            <span className="font-display text-xl font-bold text-navy" data-id="element-318" data-mp="2fsvnzoo5ybyp">4.9/5</span>
          </div>
          <p className="text-center text-[13px] font-semibold text-navy/60" data-id="element-319" data-mp="1sm3ya0o4igia">
            Join thousands of physicians using structured menopause decision resources.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-320" data-mp="1ivj3kobklw4n">
          {testimonials.map((item, index) => <li key={item.name} className={`flex flex-col rounded-2xl border border-navy/10 bg-white p-5 sm:p-6 ${index === testimonials.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-321" data-mp="1eupg1w21ijca" data-mpi={index}>
              <QuoteIcon className="h-5 w-5 shrink-0 fill-rose-mist text-rose" aria-hidden="true" data-id="element-322" data-mp="22igrkxfrasci" />
              <blockquote className="mt-3 flex-1 text-[14.5px] leading-relaxed text-navy/80 sm:text-[15.5px]" data-id="element-323" data-mp="1xjvz5k6qxcym">
                “{item.quote}”
              </blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-324" data-mp="r1h0g555ajk2">
                <img src={item.photo} alt={`Portrait of ${item.name}`} className="h-11 w-11 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-325" data-mp="m35pts71050s" />
                <div className="min-w-0" data-id="element-326" data-mp="el7v4tti6yhm">
                  <p className="truncate text-[14px] font-bold text-navy" data-id="element-327" data-mp="ek68ds34knk2">
                    {item.name} <span aria-hidden="true" data-id="element-328" data-mp="ili1w8p4dsxj">{item.flag}</span>
                  </p>
                  <p className="text-[12.5px] font-semibold text-navy/55" data-id="element-329" data-mp="4umr2qv291rb">{item.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-330" data-mp="3r2cu8u8ajuxd">
          <CtaButton label="I want to work with the 5-Min Method" subtext="One-time $27 · Instant access · 7-day guarantee" data-id="element-331" data-mp="3r3nuwl6fwmk9" />
        </div>
      </div>
    </section>;
}